import { render, staticRenderFns } from "./NewClientVersion.vue?vue&type=template&id=4fa95024"
import script from "./NewClientVersion.vue?vue&type=script&lang=js"
export * from "./NewClientVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports